module.exports = __webpack_public_path__ + "img/style.6065e1b9.jpeg";